module.exports = __webpack_public_path__ + "img/Order-Refund-Email.56e435f4.png";